/**
 * Fund selection for the Fundraising Pipeline toolbar.
 *
 * The default fund comes from cfg (app_config fundraising.default_pipeline_fund_id,
 * seeded by 20261106120600 and resolved there by NAME, not by a hardcoded id).
 * It used to be a literal PROD uuid in this file, which is a CLAUDE.md
 * violation on its own and meaningless on UAT.
 *
 * The old code also SYNTHESISED a fake option labelled 'Origin' whenever that
 * fund was missing from the list. With the fund-picker gate in place that
 * became actively wrong: a closed or cancelled Origin would be conjured back
 * into the dropdown under a hardcoded label, pointing at a fund the gate had
 * just decided to hide. FundSelect pins the current value instead, which
 * achieves the real intent — the selected fund is always visible — without
 * inventing an option.
 *
 * scope='fundraising': this board IS the fundraising process, so a fund whose
 * raise has closed does not belong in the default list. "Show all funds"
 * reaches the historic ones.
 */
import React from 'react'
import { useSelector } from 'react-redux'
import { FundSelect } from '../../../../../../core/components/FundSelect.tsx'

interface PipelineFundSelectProps {
  value: string | null
  onChange: (fundId: string | null) => void
}

export default function PipelineFundSelect({ value, onChange }: PipelineFundSelectProps) {
  const defaultFundId = useSelector(
    (state: { globalConfigs?: { fundraising_default_fund_id?: string | null } }) =>
      state.globalConfigs?.fundraising_default_fund_id ?? null
  )

  const effectiveValue = value ?? defaultFundId ?? null

  return (
    <div className='min-w-[240px] max-w-[320px]' style={{ minWidth: '240px' }}>
      <FundSelect
        scope='fundraising'
        value={effectiveValue}
        onChange={(newValue: string | number | null) =>
          onChange(newValue != null && newValue !== '' ? String(newValue) : null)
        }
        size='small'
        allowClear={false}
        placeholder='Select Fund...'
        className='bg-white'
        style={{ borderRadius: '6px', width: '100%', minHeight: '32px' }}
      />
    </div>
  )
}
